import OrderDetailsLink from './OrderDetailsLink';

export default OrderDetailsLink;
